import { render } from "./ClientRiskMatrix.vue?vue&type=template&id=293adf20&scoped=true"
import script from "./ClientRiskMatrix.vue?vue&type=script&lang=js"
export * from "./ClientRiskMatrix.vue?vue&type=script&lang=js"

import "./ClientRiskMatrix.vue?vue&type=style&index=0&id=293adf20&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-293adf20"]])

export default __exports__